import { useState } from "react";
import { POSTS } from "@/data/content";
import { PageHero } from "@/components/site/PageHero";
import { CTABand } from "@/components/site/CTABand";
import { PostCard } from "@/components/home/PostCard";
import { useSeo } from "@/hooks/useSeo";

const CATS = ["All", ...Array.from(new Set(POSTS.map((p) => p.category)))];

export default function Resources() {
  const [cat, setCat] = useState("All");
  useSeo("Resources | Bodhatek", "Guides on affordable managed IT, dispatch and nationwide onsite support.");
  const list = cat === "All" ? POSTS : POSTS.filter((p) => p.category === cat);

  return (
    <div data-testid="resources-page">
      <PageHero
        testId="resources-hero"
        eyebrow="Resources"
        lines={["Insights from", { text: "the operations desk.", className: "text-grad" }]}
        sub="Practical guides on IT costs, dispatch and onsite support. (Placeholder articles in v1.)"
      />
      <section className="bg-white py-20 sm:py-28">
        <div className="container-x">
          <div className="flex flex-wrap gap-2" role="tablist">
            {CATS.map((c) => (
              <button
                key={c}
                role="tab"
                aria-selected={cat === c}
                data-testid={`resource-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-300 ${cat === c ? "border-[#0E2657] bg-[#0E2657] text-white" : "border-slate-200 text-slate-700 hover:border-[#1777AF] hover:text-[#1777AF]"}`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="mt-12 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((p, i) => <PostCard key={p.slug} post={p} i={i} />)}
          </div>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
